module.exports = __webpack_public_path__ + "img/arrow-right-gray.32b77147.svg";